// extracted by mini-css-extract-plugin
module.exports = {"titleIn":"block_titleIn_2gfEm","layout":"block_layout_3lPTR","layoutActive":"block_layoutActive_Y05fE"};